import { Grid } from '@csp/csp-web-ui';
import { styled } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

const StyledGrid = styled(Grid)`
  ${({ theme: { breakpoints, spacing } }): string => `
    padding: ${spacing(4)} ${spacing(5)};
    ${breakpoints.down('sm')} {
      padding: ${spacing(2.5)};
    }
     ${breakpoints.up('lg')} {
      max-width: 120rem;
      width: 100%;
      margin: 0 auto;
     }
  `}
`;

export const MainContent: FC<PropsWithChildren> = ({ children }) => (
  <StyledGrid item xs={12}>
    {children}
  </StyledGrid>
);
